/**
 * React Query Configuration
 * Global query client setup with default options
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable automatic refetching on window focus
      refetchOnWindowFocus: false,
      // Cache data for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Keep unused data in cache for 10 minutes
      cacheTime: 10 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Don't retry on 404s
      retryOnMount: false,
    },
    mutations: {
      // Retry mutations once
      retry: 1,
    },
  },
});
